var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height full-width d-flex"},[_c('div',{staticClass:"d-flex ant-glass-background ant-border-right radius-0 full-height",style:({ width: `${_vm.size}px` })},[_c('dhme-wkb-inspection-plan-risks',{staticClass:"flex-1"}),_c('resize-horizontal',{on:{"size":_vm.setSize}})],1),_c('dhme-wkb-inspection-plan-risks-detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }